import { Model } from '../parents/model';

export class LoyaltyProgramCardModel extends Model {
  static ATTR_CODE = 'code';
  static ATTR_CREATED_AT = 'created_at';
  static ATTR_CUSTOMER_ID = 'customer_id';
  static ATTR_ID = 'id';
  static ATTR_UPDATED_AT = 'updated_at';

  get code() {
    return this.attributes[LoyaltyProgramCardModel.ATTR_CODE];
  }
  get createdAt() {
    return this.attributes[LoyaltyProgramCardModel.ATTR_CREATED_AT];
  }
  get customerId() {
    return this.attributes[LoyaltyProgramCardModel.ATTR_CUSTOMER_ID];
  }
  get id() {
    return this.attributes[LoyaltyProgramCardModel.ATTR_ID];
  }
  get updatedAt() {
    return this.attributes[LoyaltyProgramCardModel.ATTR_UPDATED_AT];
  }
}
